import { render, staticRenderFns } from "./checkModule.vue?vue&type=template&id=fefa82b6&scoped=true"
import script from "./checkModule.vue?vue&type=script&lang=js"
export * from "./checkModule.vue?vue&type=script&lang=js"
import style0 from "./checkModule.vue?vue&type=style&index=0&id=fefa82b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fefa82b6",
  null
  
)

export default component.exports